
import { defineComponent } from "vue";
import { useRouter } from "vue-router";

import { getHomePageActivitiesProduct } from "@/api/shopApi";
import runEvn from "@/modular/runEvn/RunEvn";
import { keepDecimal } from "@/modular/Number";

const fileBaseUrl = runEvn().fileBaseUrl;

// import 'swiper/swiper.scss';

export default defineComponent({
    name: "HomePartActivitiesView",
    setup() {
        const router = useRouter();
        return {
            router, //一定要要放在return里才能在模板上面使用
        };
    },
    data() {
        return {
            LumpList: [], // 拼团列表
            seckillList: [], // 秒杀列表
            loading: true,
        };
    },
    async mounted() {
        await this.loadData();
    },
    methods: {
        async loadData() {
            this.loading = true;
            const LumpList = await getHomePageActivitiesProduct({
                campaignType: 2,
            });
            const seckillList = await getHomePageActivitiesProduct({
                campaignType: 1,
            });

            this.LumpList = LumpList.products;
            this.seckillList = seckillList.products;
            this.loading = false;
        },
        lumpImg(key: string) {
            const arr = key.split(",") || [""];
            return this.img(arr[0]);
        },
        img(key: string) {
            return fileBaseUrl + key;
        },
        keepDecimal(numStr: number, x: number) {
            return keepDecimal(numStr, x);
        },

        toList(type: string) {
            const path = type == "1" ? "seckill" : "group";
            this.router.push({
                path: `/shop/goods/discountsList/${path}`,
                query: {
                    type: type,
                },
            });
        },
        
        goDetail(id: string, type = 0, preferentialActivitiesId: string,activityProductId: string) {
            sessionStorage.setItem("type", JSON.stringify(type));
            sessionStorage.setItem("preferentialActivitiesId", JSON.stringify(preferentialActivitiesId));
            this.router.push(
                `/shop/goods/detail/${id}?activityProductId=${activityProductId}`
            );
        },
    },
});
